
const LoaderBall = () => {

  return (
    <div className="loader-box-bg d-flex justify-content-center align-items-center">
      <div>
        <div className="loader-box">
          <div className="white-ball"></div>
          <div className="nine-ball"></div>
        </div>
        <div className="load-text mt-3">Đang tải ...</div>
      </div>
    </div>
  )
}

export default LoaderBall
